import React, {useEffect} from 'react';
import Grid from '@mui/material/Grid';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';
import PlaceIcon from '@mui/icons-material/Place';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Collapse from '@mui/material/Collapse';
import { useTheme } from '@mui/material/styles';

import WebServiceGet from '../Connectors/WebServiceGet';
import AutocompletePlz from './AutocompletePlz';
import CustomTextFieldNGX from './CustomTextFieldNGX';
import rulesText from '../Entity/rulesText' 
import validatorResult from '../Entity/validatorResult';
import ValidatorInputText from '../Module/Validatoren/ValidatorInputText';
import ValidatorInputCustomPlz from '../Module/Validatoren/ValidatorInputCustomPlz';

const validatorText = (props, fieldName, rules) => {
    if (!props.data[fieldName].touched) {
        return validatorResult(true)
    }

    if (props.data[fieldName].overrideValidator) {
        let res = props.data[fieldName].overrideValidator()
        if (res.valid !== props.data[fieldName].valid) {
            props.updaterValid(fieldName)(res.valid)
        }
        return res
    }

    if (props.data[fieldName].overrideRules) {
        rules = props.data[fieldName].overrideRules
    }

    let res =  ValidatorInputText(
        props.data[fieldName].value, rules
    );

    if (res.valid !== props.data[fieldName].valid) {
        useEffect(() => {
            props.updaterValid(fieldName)(res.valid)
        }, []);
    }

    return ValidatorInputText(
        props.data[fieldName].value, rules
    );
}

const Ort = (props) => {
    if ( !props.withCard ) {
        return (
            <div>
                {renderHeader(props)}
                {renderBody(props)}
            </div>
        );
    }

    return (
        <Card>
            {renderHeader(props)}
            <CardContent>
                {renderBody(props)}
            </CardContent>
        </Card>
    );
}

const renderHeader = (props) => {
    const theme = useTheme();
    return (
        <CardHeader
            avatar={props.withAvatar?<Avatar style={{backgroundColor:theme.palette.primary.main}}><PlaceIcon /></Avatar>:false}
            title={
                props.withAvatar
                ?<h2 style={{color:theme.palette.primary.main}}>{props.headline}</h2>
                :<span style={{color:theme.palette.primary.main}}>{props.headline}</span>
            }
            //subheader={props.subheader?props.subheader:false}
            action={
                <IconButton sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}} 
                aria-label="Exemplar löschen"
                onClick={
                    ()=> {
                    props.updaterValue("zoomIn")(!props.data.zoomIn.value)
                    }
                }
                >
                {
                    props.data.zoomIn.value
                    ?<ExpandLessIcon />
                    :<ExpandMoreIcon />
                }
                </IconButton>
            }
            style={{padding:"0px 0px 20px"}} // CardHeader default padding override
        />
    );   
}

const renderBody = (props) => {
    
  return (
    <Collapse in={props.data.zoomIn.value}>
        <Grid container spacing={2}>

            <Grid item md={4} xs={9}>
                <CustomTextFieldNGX
                    id={props.id+"Strasse"}
                    label="Straße"
                    data={props.data.strasse}
                    updaterValue={props.updaterValue('strasse')}
                    updaterTouch={props.updaterTouch('strasse')}
                    updaterValid={props.updaterValid('strasse')}
                    required={true}
                    validator={
                        () => validatorText(props,
                            "strasse",
                            rulesText(true,2)
                        )    
                    }
                    inputProps={{ 'aria-label': 'Strasse' }}
                />
            </Grid>

            <Grid item md={2} xs={3}>
                <CustomTextFieldNGX
                    id={props.id+"Hausnummer"}
                    label="Hausnummer"
                    data={props.data.hausnummer}
                    updaterValue={props.updaterValue('hausnummer')}
                    updaterTouch={props.updaterTouch('hausnummer')}
                    updaterValid={props.updaterValid('hausnummer')}
                    required={true}
                    validator={
                        () => validatorText(props,
                            "hausnummer",
                            rulesText(true,1)
                        )    
                    }
                    inputProps={{ 'aria-label': 'Hausnummer' }}
                />
            </Grid>

            <Grid item md={2} xs={3}>
                <AutocompletePlz
                    label="PLZ"
                    data={props.data.plz}
                    plzVorschlagsliste={props.data.plzVorschlagsliste.value}
                    updaterValueTextInput={
                        (input) => {
                            props.updaterValue('plz')(input)
                        }

                    }
                    updaterOrt={
                        (value) => {
                            props.updaterValue('ort')(value)
                        }

                    }
                    updaterPlzVorschlagsliste={
                        (input) => {
                            WebServiceGet(
                                props.restLadePlz,
                                input,
                                (data) => {
                                    props.updaterValue('plzVorschlagsliste')(data)
                                }
                            )
                        }
                    }
                    updaterTouch={props.updaterTouch('plz')}
                    required={props.data.plz.required}
                    validator={
                        () => {
                            useEffect(() => {
                                if (props.data.plz.touched) {
                                    let res = ValidatorInputCustomPlz(props.data.plz.value, props.data.plz.required)
                                    if (res.valid) {
                                        props.updaterValid("plz")(true)
                                    } else {
                                        props.updaterValid("plz")(false)
                                    }
                                }
                            });
                            if (props.data.plz.touched) {
                                return ValidatorInputCustomPlz(props.data.plz.value, props.data.plz.required)
                            } else {
                                return validatorResult(true);
                            }
                        }
                    }
                    inputProps={{ 'aria-label': 'Postleitzahl' }}
                />
            </Grid>

            <Grid item md={4} xs={9}>
                <CustomTextFieldNGX
                    id={props.id+"Ort"}
                    label="Ort"
                    data={props.data.ort}
                    updaterValue={props.updaterValue('ort')}
                    updaterTouch={props.updaterTouch('ort')}
                    updaterValid={props.updaterValid('ort')}
                    required={true}
                    validator={
                        () => validatorText(props,
                            "ort",
                            rulesText(true,2)
                        )    
                    }
                    inputProps={{ 'aria-label': 'Ort' }}

                />
            </Grid>

            {props.data['adresszusatz'].display &&
                <Grid item md={3} xs={12}>
                    <CustomTextFieldNGX
                        id={props.id+"Adresszusatz"}
                        label="Adresszusatz"
                        data={props.data.adresszusatz}
                        updaterValue={props.updaterValue('adresszusatz')}
                        updaterTouch={props.updaterTouch('adresszusatz')}
                        updaterValid={props.updaterValid('adresszusatz')}
                        placeholder="Optional"
                        validator={
                            () => validatorResult(true)
                        }
                        inputProps={{ 'aria-label': 'Adresszusatz' }}
                    />
                </Grid>
            }
        
        </Grid>
    </Collapse>
  );
}

export default Ort;
